import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../../base/Text';
import Styles from './Chart.styles';
import translations from './data/translations';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const DiagaonalWrapper = styled.div`${Styles.diagonalWrapper}`; // prettier-ignore
const Triangle = styled.div`${Styles.triangle}`; // prettier-ignore
const Title = styled(Text)`${Styles.title};`; // prettier-ignore
const Subtitle = styled(Text)`${Styles.subtitle};`; // prettier-ignore
const Lists = styled.ul`${Styles.lists};`; // prettier-ignore
const ListItem = styled.li`${Styles.listitem};`; // prettier-ignore
const MobileLayout = styled.div`${Styles.mobileLayout}`; // prettier-ignore
const DesktopLayout = styled.div`${Styles.desktopLayout}`; // prettier-ignore
const Description = styled.div`${Styles.description}`; // prettier-ignore
const Tips = styled.div`${Styles.tips}`; // prettier-ignore
const TipLink = styled.a`${Styles.tiplink}`; // prettier-ignore

/**
 * Map component
 * @returns {JSX}
 */
const ChartComponent = ({ locale, mapImage }) => {
  const {
    title,
    description,
    tip,
    tiplink,
    tiptext,
    countrylang,
    imgsmall,
    imglarge,
  } = translations[locale];

  return (
    <Wrapper>
      <DiagaonalWrapper>
        <div className="container">
          <MobileLayout className="row">
            <div className="col-12">
              <img src={mapImage} width="100%" alt="Tijuana airport flights" />
            </div>
          </MobileLayout>
          <DesktopLayout className="row">
            <div className="col-12">
              <img src={mapImage} width="100%" alt="Tijuana airport flights" />
            </div>
          </DesktopLayout>
        </div>
      </DiagaonalWrapper>
    </Wrapper>
  );
};

ChartComponent.propTypes = {
  locale: PropTypes.string
};
export default ChartComponent;
